import classNames from 'classnames';
import Chip from 'components/Chip/Chip';
import IconLink from 'components/IconLink/IconLink';
import { FlexBox, Spacer } from 'components/Layout/Layout';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ColorUse } from 'types/Color';
import { StepChildProps, StepKeys } from '../VideoType';

const TypeIntroSuccess = ({ videoId, setStep }: StepChildProps) => {
  const { t } = useTranslation(['translation', 'video']);
  const navigate = useNavigate();
  const handleSkip = () => {
    navigate(`/videos/${videoId}`);
  };

  return (
    <div>
      <Chip role="alert" color={ColorUse['confirm-50']}>
        {t('video:type.success')}
      </Chip>
      <Spacer tag="p" margin={[2, 0, 4]} className="c-dark-50 small">
        {t('video:type.channel.success')}
      </Spacer>

      <label className="select__label" htmlFor={`button--${videoId}`}>
        {t('channelTitle')}
      </label>
      <button
        id={`button--${videoId}`}
        type="button"
        className={classNames(
          'select__select',
          'select-interactive__fake-select',
          'select__wrap',
        )}
        onClick={() => setStep(StepKeys.SET_CHANNELS)}
      >
        <span className="select-interactive__fake-text">{t('select')}</span>
      </button>

      <FlexBox justifyContent="flex-end" marginTop={4}>
        <IconLink icon="arrow-right" onClick={handleSkip}>
          {t('video:type.skip')}
        </IconLink>
      </FlexBox>
    </div>
  );
};

export default TypeIntroSuccess;
